export enum USER_STORAGE_IDENTIFIER {
  BONUSES_LAST_SEEN_AT = 'bonuses_last_seen_at',
}
